import type { Permissions } from "@/lib/auth/permissions";

export type User = {
  sub: string;
  displayName: string;
  mail: string;
  tenantId: string;
  tenantSlug: string;
};

export type FeatureFlags = {
  useExportAnnotationCommand: boolean;
  usePresence: boolean;
  useRealTimeAnnotations: boolean;
  useZOrderTextExtraction: boolean;
};

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  useExportAnnotationCommand: false,
  usePresence: false,
  useRealTimeAnnotations: false,
  useZOrderTextExtraction: false,
};

export type AuthContextType = {
  user: User | null | undefined;
  /** Global permissions for proofing flow (no project-specific context) */
  permissions?: Permissions;
  supplierGroups: string[]; // List of group IDs where user has supplier role
  featureFlags?: FeatureFlags;
};
